import type { OverrideTokens } from '@ovComponents/0-tokens/overrideTypes';
import { merge } from 'lodash-es';
import {
  type BorderRadiusTokens,
  borderRadius,
} from './borderRadius/borderRadius';
import { type ColorTokens, useColorTokens } from './color/color';
import { type ElevationTokens, elevation } from './elevation/elevation';
import { type FontTokens, font } from './font/font';
import { type SpacingTokens, spacing } from './layout/layout';

export type SysTokens = {
  color: ColorTokens;
  borderRadius: BorderRadiusTokens;
  elevation: ElevationTokens;
  spacing: SpacingTokens;
  font: FontTokens;
};

export type OverrideSysTokens = {
  color?: ColorTokens;
  borderRadius?: BorderRadiusTokens;
  elevation?: ElevationTokens;
  spacing?: SpacingTokens;
};

export const useSysTokens = (override: OverrideTokens): SysTokens => {
  const base: SysTokens = {
    color: useColorTokens(override),
    borderRadius,
    elevation,
    spacing,
    font,
  };

  const tokens = merge({}, base, override.sys);

  return tokens;
};
